const fr = {
  meta: {
    title: "Nexora Technologies — Le partenaire européen de la transformation IA",
  },
  nav: {
    home: "Accueil",
    services: "Services",
    aiTransformation: "Transformation IA",
    industries: "Secteurs",
    about: "À propos",
    contact: "Contact",
    countries: "Pays",
    bookStrategy: "Réserver un entretien stratégique",
  },
  countriesNav: {
    netherlands: "Pays-Bas",
    germany: "Allemagne",
    switzerland: "Suisse",
    belgium: "Belgique",
    "united-kingdom": "Royaume-Uni",
  },
  langSwitcher: { label: "Langue" },
  hero: {
    eyebrow: "Le partenaire européen de la transformation IA",
    title1: "Accélérez votre montée en charge.",
    title2: "Accédez à des talents technologiques de classe mondiale.",
    subtitle:
      "Nexora Technologies aide les organisations européennes à résoudre les pénuries de talents technologiques grâce à un modèle nearshore et à la transformation IA.",
    bookDiscovery: "Planifier un appel découverte",
    requestTalent: "Demander des talents",
  },
  trustStats: [
    { value: "20+", label: "Ans de delivery international" },
    { value: "5", label: "Marchés européens servis" },
    { value: "500+", label: "Spécialistes déployés" },
    { value: "<1h", label: "Temps de réponse moyen" },
  ],
  whyUs: {
    eyebrow: "pourquoi nexora",
    title: "La technologie évolue plus vite que les organisations ne peuvent recruter.",
    lede:
      "Trouver des ingénieurs IA, architectes cloud, consultants SAP et spécialistes cybersécurité expérimentés est devenu l'un des plus grands défis en Europe.",
    body1:
      "Nexora donne aux organisations un accès immédiat à des professionnels technologiques hautement qualifiés via un modèle nearshore flexible, avec un décalage horaire minimal — permettant une collaboration fluide avec les équipes internes.",
    body2:
      "Depuis plus de 20 ans, nous livrons avec succès des programmes d'externalisation, d'insourcing et de transformation digitale pour des clients internationaux.",
    aboutLink: "À propos de Nexora",
    deliverablesEyebrow: "ce que nous livrons",
  },
  deliverables: [
    "Ingénieurs IA",
    "Spécialistes en IA générative",
    "Ingénieurs en machine learning",
    "Ingénieurs cloud",
    "Experts cybersécurité",
    "Ingénieurs DevOps",
    "Ingénieurs data",
    "Consultants SAP",
    "Équipes de développement logiciel",
    "Conseil en transformation technologique",
  ],
  servicesSection: {
    eyebrow: "services",
    title: "Une plateforme enterprise de compétences — livrée en un tout.",
    lede:
      "Des centres d'excellence IA aux pods d'ingénierie nearshore dédiés, nos services se combinent pour démultiplier votre exécution technologique.",
  },
  services: [
    {
      slug: "ai-transformation",
      title: "Transformation IA",
      summary:
        "Identifiez, concevez et opérationnalisez des cas d'usage IA à valeur métier mesurable — de la stratégie au déploiement.",
      bullets: ["Stratégie & feuille de route IA", "Solutions d'IA générative", "Gouvernance IA", "Centre d'excellence IA"],
    },
    {
      slug: "dedicated-teams",
      title: "Équipes d'ingénierie dédiées",
      summary:
        "Des pods d'ingénierie senior nearshore qui s'intègrent directement à votre delivery — même fuseau horaire, standards européens.",
      bullets: ["Delivery en pods", "Équipes pilotées par des seniors", "Gouvernance transparente", "Scalabilité flexible"],
    },
    {
      slug: "cloud",
      title: "Cloud Engineering",
      summary:
        "Architecture, migration et FinOps Azure, AWS et GCP — conçus pour la conformité et la résilience européennes.",
      bullets: ["Landing zones", "Migration cloud", "Platform engineering", "FinOps"],
    },
    {
      slug: "cybersecurity",
      title: "Cybersécurité",
      summary: "De l'architecture zero-trust à la sécurité OT — protégez votre entreprise à chaque niveau.",
      bullets: ["Conception zero-trust", "Sécurité cloud", "Identités & accès", "Sécurité OT / IoT"],
    },
    {
      slug: "sap",
      title: "SAP & plateformes enterprise",
      summary:
        "Programmes S/4HANA, BTP et de modernisation enterprise menés par des consultants seniors certifiés.",
      bullets: ["Migration S/4HANA", "Développement BTP", "Intégration", "Services managés"],
    },
    {
      slug: "software-engineering",
      title: "Software Engineering",
      summary:
        "Ingénierie produit de bout en bout — discovery, design, build et modernisation — à la qualité européenne.",
      bullets: ["Ingénierie produit", "Modernisation plateforme", "QA & DevOps", "Plateformes API"],
    },
  ],
  countriesSection: {
    eyebrow: "nos marchés",
    title: "Conçu pour le delivery européen.",
    lede:
      "Des pods pilotés par des seniors opérant dans votre fuseau horaire, avec une connaissance locale dans cinq pays européens clés.",
    exploreLabel: "Découvrir",
  },
  aiFeature: {
    eyebrow: "transformation ia",
    title: "L'intelligence artificielle n'est plus une initiative d'avenir.",
    lede:
      "Elle est devenue une nécessité concurrentielle. Nexora aide les organisations à identifier, concevoir et déployer des solutions IA à valeur métier mesurable.",
    tags: ["Stratégie IA", "IA générative", "Gouvernance IA", "Centre d'excellence IA"],
    exploreLink: "Découvrir les services de transformation IA",
  },
  principles: {
    eyebrow: "notre fonctionnement",
    title: "Conçu pour l'entreprise européenne.",
    lede:
      "Notre modèle de delivery est conçu pour la transparence, la gouvernance et des résultats pilotés par des seniors.",
    items: [
      {
        title: "Engagements pilotés par des seniors",
        desc:
          "Chaque programme est dirigé par des ingénieurs et conseillers seniors — pas de profils juniors cachés derrière une marque.",
      },
      {
        title: "Standards européens",
        desc:
          "Delivery RGPD-native, gouvernance alignée sur l'EU AI Act, et modèle nearshore aux mêmes heures de bureau.",
      },
      {
        title: "Résultats avant heures",
        desc:
          "Nous nous engageons sur des résultats mesurables, pas sur des feuilles de temps. Nos pods sont responsables de bout en bout.",
      },
      {
        title: "Gouvernance transparente",
        desc:
          "Dashboards de delivery ouverts, rituels de pilotage hebdomadaires, visibilité totale sur la vélocité et les risques.",
      },
    ],
  },
  finalCta: {
    eyebrow: "prochaine étape",
    heading: "Construisons votre avantage concurrentiel.",
    lede:
      "Échangez avec un stratège senior Nexora. En un appel, nous cartographions les mouvements technologiques et IA à plus fort impact pour votre organisation.",
    button: "Réserver un entretien stratégique",
    exploreBtn: "Découvrir nos services",
  },
  leadForm: {
    stepLabels: ["Pays", "Compétences", "Taille de l'équipe", "Durée", "Vos coordonnées"],
    country: { title: "Quel pays ?", lede: "Choisissez où vous avez besoin de talents technologiques senior." },
    skills: {
      title: "Quelles compétences recherchez-vous ?",
      lede: "Sélectionnez tout ce qui s'applique. Vous pouvez combiner des spécialistes ou décrire une équipe complète.",
    },
    teamSize: {
      title: "Quelle doit être la taille de l'équipe ?",
      lede: "Nous pouvons mettre à l'échelle d'un seul spécialiste senior à un pod complet.",
    },
    duration: {
      title: "Quelle est la durée de l'engagement ?",
      lede: "La plupart des engagements démarrent à 3 mois et se prolongent selon les résultats.",
    },
    details: {
      title: "Vos coordonnées",
      lede: "Nous orientons votre demande vers le stratège senior approprié.",
      name: "Nom complet",
      email: "E-mail professionnel",
      company: "Entreprise",
      message: "Que cherchez-vous à accomplir ? (facultatif)",
      namePh: "Jeanne Martin",
      emailPh: "jeanne@entreprise.eu",
      companyPh: "Votre organisation",
      messagePh: "Décrivez brièvement votre initiative, vos délais et toute contrainte.",
    },
    back: "Retour",
    next: "Continuer",
    send: "Envoyer la demande",
    sending: "Envoi…",
    successTitle: "Demande reçue.",
    successLede:
      "Merci. Un stratège senior Nexora vous contactera sous un jour ouvré pour planifier votre appel découverte.",
    errorGeneric: "Une erreur est survenue. Veuillez réessayer.",
    toastSuccessTitle: "Demande reçue",
    toastSuccessDesc: "Un stratège Nexora vous contactera sous un jour ouvré.",
    toastErrorTitle: "Échec de l'envoi",
  },
  skills: {
    "ai-engineers": "Ingénieurs IA",
    "generative-ai": "Spécialistes en IA générative",
    "ml-engineers": "Ingénieurs ML",
    mlops: "Ingénieurs MLOps",
    "data-engineers": "Ingénieurs data",
    "data-scientists": "Data scientists",
    "cloud-engineers": "Ingénieurs cloud (Azure / AWS / GCP)",
    "cloud-architects": "Architectes cloud",
    devops: "Ingénieurs DevOps",
    cybersecurity: "Spécialistes cybersécurité",
    sap: "Consultants SAP",
    "software-dev": "Équipes de développement logiciel",
    java: "Développeurs Java",
    dotnet: "Développeurs .NET",
    python: "Développeurs Python",
    fullstack: "Développeurs full stack",
    "power-platform": "Microsoft Power Platform",
    salesforce: "Consultants Salesforce",
    transformation: "Conseil en transformation technologique",
  },
  teamSizes: {
    "1-3": "1 – 3 spécialistes",
    "4-6": "4 – 6 spécialistes",
    "7-10": "7 – 10 spécialistes",
    "10-plus": "10+ spécialistes",
  },
  durations: {
    "3m": "3 mois",
    "6m": "6 mois",
    "12m": "12 mois",
    ongoing: "Partenariat continu",
  },
  contactPage: {
    eyebrow: "Réserver un entretien stratégique",
    title1: "Construisons votre",
    title2: "avantage concurrentiel.",
    lede:
      "Parlez-nous de l'initiative de talents technologiques ou de transformation IA que vous préparez. Un stratège senior Nexora vous contactera sous un jour ouvré.",
    directHeading: "direct",
    addressList: "Amsterdam · Francfort · Zurich · Bruxelles · Londres",
    whatToExpectHeading: "ce qui vous attend",
    whatToExpectList: [
      "Réponse sous un jour ouvré",
      "Appel découverte avec un stratège senior",
      "Proposition sur mesure en <5 jours",
      "Sans engagement, confidentialité totale",
    ],
  },
  aboutPage: {
    eyebrow: "À propos",
    title1: "Le partenaire européen",
    title2: "de la transformation IA.",
    lede:
      "Nexora Technologies aide les organisations européennes à mettre à l'échelle leurs capacités technologiques grâce à la transformation IA, à des talents rares et à des équipes d'ingénierie nearshore dédiées.",
    missionEyebrow: "notre mission",
    missionTitle: "Aider l'entreprise européenne à rester compétitive à l'ère de l'IA.",
    missionPara1:
      "Depuis plus de 20 ans, nous livrons des programmes d'externalisation, d'insourcing et de transformation digitale pour des clients internationaux. Aujourd'hui, notre mission est unique : aider les organisations européennes à gagner à l'ère de l'IA.",
    missionPara2:
      "Nous combinons des talents technologiques rares, un modèle nearshore gouverné et une expertise IA approfondie pour offrir à nos clients la vitesse d'exécution exigée par la concurrence moderne.",
    missionList: [
      "Approuvé par des entreprises internationales sur cinq marchés européens clés",
      "Pods pilotés par des seniors — jamais des juniors cachés derrière une marque",
      "Engagements orientés résultats avec gouvernance transparente",
      "Delivery AI-native, RGPD-native by design",
    ],
  },
  servicesPage: {
    eyebrow: "Services",
    title1: "Une plateforme enterprise",
    title2: "de capacités technologiques.",
    lede:
      "Six services interconnectés — combinés en un modèle de delivery gouverné qui démultiplie l'exécution technologique des entreprises européennes.",
    talkLink: "Parler à un conseiller",
  },
  industriesPage: {
    eyebrow: "Secteurs",
    title1: "Conçu pour les secteurs",
    title2: "où la technologie décide qui l'emporte.",
    lede:
      "Des équipes de delivery sectorielles qui comprennent la dynamique, la réglementation et la réalité concurrentielle de votre secteur.",
    talkLink: "Contactez-nous",
  },
  industries: [
    { slug: "financial-services", title: "Services financiers", desc: "Banque, assurance et marchés de capitaux." },
    { slug: "government", title: "Secteur public", desc: "Services publics numériques et cloud souverain." },
    { slug: "healthcare", title: "Santé & Life Sciences", desc: "Transformation clinique, recherche et pharma." },
    { slug: "energy", title: "Énergie & utilities", desc: "Transition énergétique, réseaux intelligents, sécurité OT." },
    { slug: "manufacturing", title: "Industrie", desc: "Industrie 4.0, usines intelligentes, IA supply chain." },
    { slug: "retail", title: "Retail & e-commerce", desc: "Omnicanal, personnalisation et IA demande." },
    { slug: "logistics", title: "Logistique & transport", desc: "Réseaux, intelligence routière et jumeaux numériques." },
    { slug: "telecom", title: "Télécommunications", desc: "Modernisation réseau et IA client." },
  ],
  aiPage: {
    eyebrow: "Transformation IA",
    title1: "L'intelligence artificielle",
    title2: "n'est plus une initiative d'avenir.",
    lede:
      "Elle est devenue une nécessité concurrentielle. Nexora Technologies aide les organisations à identifier, concevoir et déployer des solutions IA à valeur métier mesurable.",
    startBtn: "Démarrer votre AI Readiness Assessment",
    allServicesBtn: "Voir tous les services",
    servicesEyebrow: "services ia",
    servicesTitle: "Une capacité IA complète.",
    servicesLede:
      "Du conseil et de la gouvernance à l'ingénierie et aux opérations — Nexora livre l'IA comme une capacité managée et responsable.",
    approachEyebrow: "notre approche",
    approachTitle: "De la stratégie à la mise à l'échelle, en quatre phases gouvernées.",
    approachLede:
      "Nexora fait passer l'IA de l'ambition à des résultats enterprise-grade — sans le cimetière de PoC habituel.",
    talkLink: "Parler à un conseiller IA",
    services: [
      { title: "Stratégie IA", desc: "Définissez les initiatives IA à plus forte valeur, alignées sur votre stratégie." },
      { title: "AI Readiness Assessment", desc: "Évaluez la maturité de vos données, talents, infrastructure et gouvernance." },
      { title: "Gouvernance IA", desc: "Opérez l'IA de manière responsable avec politiques, contrôles et alignement EU AI Act." },
      { title: "AI Factory Advisory", desc: "Concevez un modèle de delivery reproductible qui fait passer l'IA du PoC à la production." },
      { title: "Solutions d'IA générative", desc: "Construisez des copilots, agents et systèmes de connaissance sur vos données." },
      { title: "Automatisation IA", desc: "Automatisez des workflows complexes en combinant LLMs, RPA et intelligence processus." },
      { title: "Intégration IA", desc: "Intégrez l'IA dans vos systèmes cœur — CRM, ERP, plateformes data et au-delà." },
      { title: "Conseil infrastructure IA", desc: "Architecturez les fondations GPU, MLOps et plateforme pour l'IA en production." },
      { title: "Formation IA", desc: "Montez en compétence dirigeants et ingénieurs avec des programmes IA par rôle." },
      { title: "Centre d'excellence IA", desc: "Mettez en place un CoE qui orchestre la valeur IA à l'échelle de l'entreprise." },
    ],
    phases: [
      { step: "01", title: "Diagnostic", desc: "Readiness IA, carte de valeur et base de gouvernance." },
      { step: "02", title: "Design", desc: "Architecture solution, fondations data, target operating model." },
      { step: "03", title: "Livraison", desc: "Construire, intégrer et opérer avec des pods seniors." },
      { step: "04", title: "Mise à l'échelle", desc: "CoE IA, MLOps, cycle de vie modèle et suivi de valeur." },
    ],
  },
  notFound: {
    eyebrow: "404",
    title: "Page introuvable.",
    body: "La page que vous cherchez n'existe pas — mais nous serions ravis d'échanger malgré tout.",
    backBtn: "Retour à l'accueil",
  },
  country: {
    common: {
      specialistsEyebrow: "les plus demandés",
      specialistsTitle: "Spécialistes les plus demandés",
      specialistsLede:
        "Des rôles où la demande dépasse l'offre — et où Nexora livre le plus vite.",
      industriesEyebrow: "secteurs",
      industriesTitle: "Secteurs que nous servons",
      whyEyebrow: "pourquoi nexora",
      whyTitle: "Pourquoi les équipes choisissent Nexora",
      formEyebrow: "demander des talents",
      formTitle: "Construisons votre avantage concurrentiel.",
      formLede: "Dites-nous quels profils vous cherchez — nous répondons sous un jour ouvré.",
      formCta: "Demander des talents",
      exploreLabel: "Voir les services",
      finalHeading: "Construisons votre avantage concurrentiel.",
      finalCta: "Réserver un entretien stratégique",
      bullets: [
        "Équipes pilotées par des seniors · delivery nearshore",
        "Qualité européenne, RGPD-native",
        "Onboarding rapide · scalabilité flexible",
      ],
    },
    netherlands: {
      eyebrow: "Pays-Bas",
      title: "Talents technologiques pour les Pays-Bas",
      lede:
        "Le marché technologique néerlandais croît plus vite que les talents disponibles. Nous aidons les organisations à mettre rapidement à l'échelle leurs équipes avec des professionnels très expérimentés, quasiment dans le même fuseau horaire.",
      body:
        "Que vous construisiez des solutions IA, migriez vers Azure, modernisiez SAP ou renforciez votre cybersécurité — nous fournissons les bons spécialistes au moment précis où vous en avez besoin.",
      specialists: [
        "Ingénieurs IA",
        "Ingénieurs Azure cloud",
        "Spécialistes cybersécurité",
        "Ingénieurs DevOps",
        "Ingénieurs data",
        "Spécialistes Microsoft Power Platform",
        "Consultants SAP",
        "Développeurs Java",
        "Développeurs full stack",
        "Analystes data",
      ],
      industries: ["Services financiers", "Secteur public", "Santé", "Énergie", "Logistique", "Retail", "Industrie"],
      whyUs: [
        "Collaboration nearshore",
        "Décalage horaire minimal",
        "Onboarding rapide",
        "Équipes dédiées",
        "Scalabilité flexible",
        "20+ ans d'expérience internationale",
      ],
    },
    germany: {
      eyebrow: "Allemagne",
      title: "Spécialistes IT pour le marché allemand",
      lede:
        "La pénurie de compétences ne doit pas freiner votre croissance. Nos équipes nearshore s'intègrent parfaitement à votre organisation et livrent la meilleure qualité.",
      body:
        "Qu'il s'agisse d'IA, de migration cloud, de modernisation SAP ou de cybersécurité — nous livrons les bons experts au moment précis où vous en avez besoin.",
      specialists: [
        "Consultants SAP S/4HANA",
        "Ingénieurs IA",
        "Spécialistes cybersécurité",
        "Architectes cloud",
        "Ingénieurs DevOps",
        "Ingénieurs embedded software",
        "Ingénieurs data",
        "Développeurs Java",
        "Platform engineers",
        "Spécialistes sécurité OT",
      ],
      industries: ["Automobile", "Industrie", "Finance", "Santé", "Énergie", "Secteur public"],
      whyUs: [
        "Collaboration nearshore",
        "Décalage horaire minimal",
        "Onboarding rapide",
        "Équipes dédiées",
        "Scalabilité flexible",
        "20+ ans d'expérience internationale",
      ],
    },
    switzerland: {
      eyebrow: "Suisse",
      title: "Excellence technologique pour la Suisse",
      lede:
        "Les organisations suisses exigent une expertise technologique de classe mondiale. Nos spécialistes livrent des solutions enterprise-grade en collaborant sur des horaires quasi identiques.",
      body:
        "De la banque privée à la R&D pharmaceutique — nous livrons les technologues seniors sur lesquels comptent les entreprises suisses.",
      specialists: [
        "Ingénieurs IA",
        "Développeurs quant",
        "Ingénieurs cloud security",
        "Spécialistes cybersécurité",
        "Architectes Azure",
        "Ingénieurs DevSecOps",
        "Ingénieurs data",
        "Ingénieurs MLOps",
        "Architectes logiciel",
        "Ingénieurs blockchain",
      ],
      industries: ["Banque", "Assurance", "Life sciences", "Pharma", "Santé", "Industrie"],
      whyUs: [
        "Équipes pilotées par des seniors",
        "Qualité suisse",
        "Collaboration le jour même",
        "Gestion souveraine des données",
        "Expérience en secteurs régulés",
        "20+ ans d'expérience internationale",
      ],
    },
    belgium: {
      eyebrow: "Belgique",
      title: "Des talents technologiques qui accélèrent l'innovation",
      lede:
        "Trouver des professionnels IT expérimentés n'a jamais été aussi difficile. Nos équipes nearshore offrent une capacité immédiate tout en maintenant les standards européens.",
      body:
        "Des institutions européennes à Bruxelles aux services financiers et life sciences — Nexora livre dans les secteurs les plus exigeants de Belgique.",
      specialists: [
        "Ingénieurs Azure",
        "Consultants SAP",
        "Spécialistes cybersécurité",
        "Ingénieurs data",
        "Développeurs Java",
        "Développeurs .NET",
        "Ingénieurs DevOps",
        "Ingénieurs IA",
        "Spécialistes business intelligence",
        "Ingénieurs cloud operations",
      ],
      industries: ["Institutions européennes", "Services financiers", "Chimie", "Logistique", "Santé", "Secteur public"],
      whyUs: [
        "Collaboration bilingue",
        "Conformité UE",
        "Équipes de delivery seniors",
        "Scalabilité flexible",
        "Focus Bruxelles & Anvers",
        "20+ ans d'expérience internationale",
      ],
    },
    "united-kingdom": {
      eyebrow: "Royaume-Uni",
      title: "Talents technologiques de classe mondiale pour les organisations britanniques",
      lede:
        "Mettez à l'échelle plus vite avec des spécialistes technologiques très expérimentés. Nous livrons des équipes d'ingénierie dédiées avec un décalage horaire minimal.",
      body:
        "De la FinTech londonienne aux programmes de défense et d'énergie à l'échelle nationale — Nexora livre des équipes pilotées par des seniors au niveau de qualité britannique.",
      specialists: [
        "Ingénieurs IA",
        "Spécialistes cybersécurité",
        "Ingénieurs cloud",
        "Ingénieurs DevOps",
        "Data scientists",
        "Développeurs Python",
        "Développeurs Java",
        "Consultants Salesforce",
        "Architectes AWS",
        "Platform engineers",
      ],
      industries: ["Services financiers", "FinTech", "Santé", "Retail", "Défense", "Énergie", "Télécommunications"],
      whyUs: [
        "Collaboration le jour même",
        "Pods pilotés par des seniors",
        "Standards de qualité britanniques",
        "Onboarding rapide",
        "Scalabilité flexible",
        "20+ ans d'expérience internationale",
      ],
    },
  },
  footer: {
    tagline:
      "Le partenaire européen de la transformation IA. Nous aidons les organisations européennes à mettre à l'échelle leurs capacités technologiques via la transformation IA, des talents rares et des équipes d'ingénierie nearshore dédiées.",
    company: "Entreprise",
    servicesCol: "Services",
    countriesCol: "Pays",
    about: "À propos",
    whyNexora: "Pourquoi Nexora",
    contact: "Contact",
    aiTransformation: "Transformation IA",
    servicesOverview: "Aperçu des services",
    industries: "Secteurs",
    privacy: "Confidentialité",
    terms: "Conditions",
    cookies: "Cookies",
    copyright: "Tous droits réservés.",
    address: "Amsterdam · Francfort · Zurich · Bruxelles · Londres",
  },
  brandTagline: "Le partenaire européen de la transformation IA",
};

export default fr;
